"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMap = exports.initMapOnScroll = void 0;
const scroll_father_1 = require("scroll-father");
const helpers_1 = require("../../../../scripts/helpers");
const MAP_SELECTOR = '#map';
let zoom = 10;
let mapInited = false;
let cities = null;
let cityDefault = null;
let points = null;
let centerMap = null;
let $mapInfoPanel = null;
const INFO_INFOPANEL_ACTIVE_CLASS = 'map__descr--active';
const initMapOnScroll = ($mapSection, urlCities, yandexMapSrc) => {
    (0, scroll_father_1.initIntersectionSection)($mapSection, () => {
        if (mapInited)
            return;
        (0, exports.initMap)($mapSection, urlCities, yandexMapSrc);
    }, () => { }, // onEnd можно оставить null, так как нас не интересует момент, когда карта выходит из области видимости
    {
        rootMargin: '0px 0px', // Опционально, настройте отступы области видимости
        threshold: 0.1, // Настраиваем, чтобы карта загружалась, как только 10% элемента становятся видимыми
    });
};
exports.initMapOnScroll = initMapOnScroll;
const initMap = ($mapSection, urlCities, yandexMapSrc) => {
    const $map = $mapSection.querySelector(MAP_SELECTOR);
    if (!$map) {
        return;
    }
    else {
        if (mapInited)
            return;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = yandexMapSrc;
        script.fetchPriority = 'low';
        script.setAttribute('defer', '');
        $map.after(script);
        script.addEventListener('load', () => {
            window.ymaps.ready(() => {
                showMap($map, urlCities, $mapSection);
            });
        });
        mapInited = true;
    }
};
exports.initMap = initMap;
function showMap($map, urlCities, $mapSection) {
    return __awaiter(this, void 0, void 0, function* () {
        const ymaps = window.ymaps;
        if (!cities) {
            cities = yield (0, helpers_1.getUrl)(urlCities);
            if (!cityDefault) {
                cityDefault = cities.find(city => city.default);
                centerMap = cityDefault.center;
                zoom = cityDefault.zoom;
            }
        }
        const map = (window.map = new ymaps.Map($map, {
            center: centerMap,
            zoom: zoom,
            controls: [],
            balloonContentLayout: ymaps.templateLayoutFactory.createClass('<h3>{{ properties.name }}</h3>' +
                '<p>Население: {{ properties.population|default:"неизвестно" }}</p>' +
                '<p>Метрополитен: {% if properties.metro %}да{% else %}нет{% endif %}</p>'),
        })), objectManager = new ymaps.ObjectManager({
            clusterize: true,
        });
        if (cities && !points) {
            points = cities.reduce((res, city) => {
                if (!city.disabled) {
                    city.items.forEach(item => {
                        res.push(item);
                    });
                }
                return res;
            }, []);
        }
        const dataPoints = map.container._parentElement.getAttribute('data-points');
        if (dataPoints)
            points = JSON.parse(dataPoints);
        objectManager.add({
            type: 'FeatureCollection',
            features: points,
        });
        const markerLayout = ymaps.templateLayoutFactory.createClass('<svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" fill="none"><rect width="47" height="47" x="1" y="1" fill="#2B6861" rx="23.5"/><rect width="47" height="47" x="1" y="1" stroke="#fff" stroke-width="2" rx="23.5"/><path fill="#fff" d="M28.5 21.13c-.41 0-.75-.34-.75-.75V19c0-1.05-.45-2.07-1.23-2.78-.79-.72-1.81-1.05-2.89-.95-1.8.17-3.38 2.01-3.38 3.93v.97c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.98c0-2.69 2.17-5.17 4.74-5.42 1.5-.14 2.94.33 4.04 1.34A5.27 5.27 0 0 1 29.25 19v1.38c0 .41-.34.75-.75.75"/><path fill="#fff" d="M27 35.25h-6c-4.62 0-5.48-2.15-5.7-4.24l-.75-5.99c-.11-1.08-.15-2.63.9-3.79.9-1 2.39-1.48 4.55-1.48h8c2.17 0 3.66.49 4.55 1.48 1.04 1.16 1.01 2.71.9 3.77l-.75 6.01c-.22 2.09-1.08 4.24-5.7 4.24m-7-14c-1.69 0-2.85.33-3.44.99-.49.54-.65 1.37-.52 2.61l.75 5.99c.17 1.6.61 2.92 4.21 2.92h6c3.6 0 4.04-1.31 4.21-2.9l.75-6.01c.13-1.22-.03-2.05-.52-2.6-.59-.67-1.75-1-3.44-1z"/><path fill="#fff" d="M27.42 25.65c-.56 0-1.01-.45-1.01-1s.45-1 1-1 1 .45 1 1-.44 1-.99 1M20.42 25.65c-.56 0-1.01-.45-1.01-1s.45-1 1-1 1 .45 1 1-.44 1-.99 1"/></svg>');
        const markerActiveLayout = ymaps.templateLayoutFactory.createClass('<svg xmlns="http://www.w3.org/2000/svg" width="86" height="101" fill="none"><path fill="#DB7B48" d="M45 97.418c0-6.414 5.147-11.523 11.249-13.497C73.514 78.335 86 62.125 86 43 86 19.252 66.748 0 43 0S0 19.252 0 43c0 18.865 12.15 34.892 29.05 40.686C35.015 85.73 40 90.79 40 97.097V100a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1z"/><path fill="#fff" d="M50.875 38.102a1.32 1.32 0 0 1-1.312-1.312v-2.416a6.62 6.62 0 0 0-2.153-4.865c-1.382-1.26-3.167-1.837-5.057-1.662-3.15.297-5.916 3.517-5.916 6.877v1.698c0 .718-.594 1.313-1.312 1.313a1.32 1.32 0 0 1-1.312-1.313v-1.715c0-4.707 3.797-9.047 8.295-9.485 2.625-.245 5.145.577 7.07 2.345a9.22 9.22 0 0 1 3.01 6.807v2.415c0 .718-.596 1.313-1.313 1.313"/><path fill="#fff" d="M37.749 62.813h10.5c8.085 0 9.59-3.763 9.975-7.42l1.312-10.518c.193-1.855.245-4.568-1.575-6.597-1.557-1.733-4.165-2.59-7.962-2.59h-14c-3.78 0-6.388.84-7.963 2.59-1.837 2.03-1.767 4.742-1.575 6.632l1.313 10.483c.385 3.657 1.89 7.42 9.975 7.42"/></svg>');
        const clusterLayout = ymaps.templateLayoutFactory.createClass('<div class="cluster_custom"><span>$[properties.geoObjects.length]</span>' +
            '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="24" cy="24" r="23" fill="white" stroke="#132346" stroke-width="2"/>' +
            '</svg>' +
            '</div>');
        objectManager.objects.options.set({
            iconLayout: markerLayout,
            iconPane: 'overlaps',
        });
        objectManager.clusters.options.set({
            clusterIconLayout: clusterLayout,
            iconPane: 'overlaps',
        });
        map.geoObjects.add(objectManager);
        if (!$mapInfoPanel) {
            $mapInfoPanel = $mapSection.querySelector('#mapInfopanel');
            // ! Закрытие mapInfopanel при клике
            const $close = $mapInfoPanel.querySelector('.map__descr-close');
            $close.addEventListener('click', () => {
                $mapInfoPanel.classList.remove(INFO_INFOPANEL_ACTIVE_CLASS);
            });
        }
        // ! Установка placemarkers по умолчанию
        let objectIdActive = Object.values(objectManager.objects._objectsById).find((obj) => obj.default).id || null;
        setIcon(objectIdActive, markerActiveLayout);
        // ! События нажатия на placemarkers
        objectManager.objects.events.add('click', function (e) {
            const objectId = e.get('objectId');
            const objectData = objectManager.objects.getById(objectId);
            if (objectData) {
                closeInfoPanelAnimation();
                updateInfoPanel(objectData, $mapInfoPanel);
                openInfoPanelAnimation();
            }
            // ! Установка специального icon на нажатом placemark
            if (objectIdActive)
                setIcon(objectIdActive, markerLayout);
            setIcon(objectId, markerActiveLayout);
            objectIdActive = objectId;
            // ! Клик по табу чтобы активировать таб соответствующий точке нажатой на карте
            const $btnTarget = Array.from(btnsCity).find($btn => {
                if ($btn.hasAttribute('data-data')) {
                    const id = JSON.parse($btn.getAttribute('data-data')).id;
                    return objectIdActive === id;
                }
            });
            // ! (Получается двойное выделение точки (повторное после имитации клика на таб - там тоже выделение точки происходит))
            $btnTarget.click();
            $btnCityActive = $btnTarget;
        });
        let infoEls = {
            city: $mapInfoPanel.querySelector('.map__descr-city'),
            address: $mapInfoPanel.querySelector('.map__descr-address'),
            telBox: $mapInfoPanel.querySelector('.map__descr-tel-box'),
            tel: $mapInfoPanel.querySelector('.map__descr-tel'),
            emailBox: $mapInfoPanel.querySelector('.map__descr-email-box'),
            email: $mapInfoPanel.querySelector('.map__descr-email'),
            schedule: $mapInfoPanel.querySelector('.map__descr-schedule'),
            scheduleBox: $mapInfoPanel.querySelector('.map__descr-schedule-box'),
        };
        function updateInfoPanel(data, $mapInfoPanel) {
            infoEls.city.textContent = data.location;
            infoEls.address.textContent = data.address;
            if (data.tel) {
                infoEls.tel.textContent = data.tel;
                infoEls.tel.href = 'tel:' + data.tel;
                infoEls.telBox.classList.remove('map__descr--hidden');
            }
            else {
                infoEls.telBox.classList.add('map__descr--hidden');
            }
            if (data.email) {
                infoEls.email.textContent = data.email;
                infoEls.email.href = 'mailto:' + data.email;
                infoEls.emailBox.classList.remove('map__descr--hidden');
            }
            else {
                infoEls.emailBox.classList.add('map__descr--hidden');
            }
            if (data.schedule) {
                infoEls.schedule.innerHTML = data.schedule;
                infoEls.scheduleBox.classList.remove('map__descr--hidden');
            }
            else {
                infoEls.scheduleBox.classList.add('map__descr--hidden');
            }
        }
        objectManager.objects.options.set({
            // ! Отключение подписей при нажатии на placemarker
            balloonContentLayout: null,
            // balloonContentLayout: ymaps.templateLayoutFactory.createClass(
            // 	'<div class="card card--objects">' +
            // 		'<h3 class="card__title">{{ properties.name }}</h3>' +
            // 		'</div>',
            // ),
            //balloonContentLayout: ymaps.templateLayoutFactory.createClass(
            //  '<h3>{{ properties.name }}</h3>' +
            //  )
        });
        //'<p>Население: {{ properties.population|default:"неизвестно" }}</p>' +
        //'<p>Метрополитен: {% if properties.metro %}да{% else %}нет{% endif %}</p>'
        // const activePoint = map.container._parentElement.getAttribute('data-active-objects');
        // let activePointObj;
        // if (activePoint) activePointObj = points.find(obj => obj['id'] == activePoint);
        const openPoint = map.container._parentElement.getAttribute('data-point-open');
        if (openPoint) {
            //if (openPoint && dataPoints) {
            const coor = objectManager.objects.getById(openPoint).geometry.coordinates;
            goToPlace(coor, 18);
            objectManager.objects.balloon.open(openPoint);
        }
        function goToPlace(center, z = zoom, idBalloon) {
            // Получение координат из названия локации
            // ymaps.geocode(center).then(function (r) {
            // 	const coords = Array.isArray(center) ? center : r.geoObjects.get(0).geometry.getCoordinates();
            //map.setCenter(coords);
            //map.setZoom(z, { smooth: true })
            map.panTo(center).then(function () {
                if (idBalloon) {
                    objectManager.objects.balloon.open(idBalloon);
                }
            });
            // });
        }
        const dataZoom = map.container._parentElement.getAttribute('data-zoom');
        const dataCenter = map.container._parentElement.getAttribute('data-center');
        if (dataCenter) {
            let placeZoom = zoom;
            if (dataZoom) {
                placeZoom = dataZoom;
            }
            goToPlace(JSON.parse(dataCenter), placeZoom);
        }
        const dataCity = map.container._parentElement.getAttribute('data-city');
        if (dataCity) {
            let placeZoom = zoom;
            if (dataZoom) {
                placeZoom = dataZoom;
            }
            goToPlace(dataCity, placeZoom);
        }
        // !?
        const goToBusLink = $mapSection.querySelector('.go-to-bus');
        if (goToBusLink) {
            const stopCoords = [53.849275, 27.473227];
            goToBusLink.addEventListener('click', function () {
                goToPlace(stopCoords, 18);
            });
        }
        map.geoObjects.events
            .add('balloonopen', function (e) {
            const targetId = e.get('objectId');
            objectManager.objects.setObjectOptions(targetId, {
                iconLayout: markerActiveLayout,
            });
        })
            .add('balloonclose', function (e) {
            const targetId = e.get('objectId');
            objectManager.objects.setObjectOptions(targetId, {
                iconLayout: markerLayout,
            });
        });
        document.addEventListener('click', function (e) {
            const resultItem = e.target.closest('.mapresults__item');
            if (resultItem) {
                const value = resultItem.getAttribute('data-value');
                const id = resultItem.getAttribute('data-id');
                goToPlace(value, 18, id);
                e.target.closest('.mapresults').classList.add('empty');
                const mapSearch = $mapSection.querySelector('#mapSearch');
                if (mapSearch) {
                    mapSearch.value = '';
                }
            }
        });
        const customProvider = {
            suggest: function (query, options) {
                var r = find(points, query), arrayResult = [];
                const res = r.filter(el => {
                    //if (el.properties.location)
                    //    return citySelect.value.trim() === el.properties.location.trim();
                    //else
                    return true;
                });
                const results = Math.min(options.results, res.length);
                for (var i = 0; i < results; i++) {
                    arrayResult.push({
                        id: res[i].id,
                        // name: res[i].properties.name,
                        value: res[i].geometry.coordinates,
                    });
                }
                return ymaps.vow.resolve(arrayResult);
            },
        };
        const customResults = ymaps.templateLayoutFactory.createClass('<div class="mapresults {% if state.items.length == 0 %}empty{% endif %}"><ul class="mapresults__inner">{% for item in state.items %}<li class="mapresults__item" data-id="{{ item.id }}" data-value="{{ item.value }}"><span class="mapresults__item-name">{{ item.name }}</span></li>{% endfor %}</ul></div>');
        const searchInput = document.getElementById('mapSearch');
        new ymaps.SuggestView(searchInput, {
            offset: [0, 4],
            provider: customProvider,
            layout: customResults,
        });
        const citySelect = $mapSection.querySelector('.map__select-city');
        if (citySelect) {
            citySelect.addEventListener('change', function () {
                const city = citySelect.value;
                if (city) {
                    goToPlace(city);
                }
            });
        }
        // ! Нажатия на табы = точки на карте
        const btnsCity = $mapSection.getElementsByClassName('map__btn-city');
        let $btnCityActive = btnsCity[0];
        for (const $btnCity of btnsCity) {
            $btnCity.addEventListener('click', () => {
                try {
                    $btnCityActive.classList.remove('button-primary--active');
                    $btnCityActive = $btnCity;
                    $btnCityActive.classList.add('button-primary--active');
                    if ($btnCity.hasAttribute('data-coords')) {
                        const coords = JSON.parse($btnCity.getAttribute('data-coords'));
                        goToPlace(coords);
                    }
                    // ! Выбор точки на карте по нажатию на таб (с данными точки)
                    if ($btnCity.hasAttribute('data-data')) {
                        const data = JSON.parse($btnCity.getAttribute('data-data'));
                        const objectId = data.id;
                        if (data) {
                            closeInfoPanelAnimation();
                            updateInfoPanel(data, $mapInfoPanel);
                            openInfoPanelAnimation();
                        }
                        // ! Установка специального icon на нажатом placemark
                        if (objectIdActive)
                            setIcon(objectIdActive, markerLayout);
                        setIcon(objectId, markerActiveLayout);
                        objectIdActive = objectId;
                    }
                }
                catch (error) {
                    console.warn(error);
                }
            });
        }
        function find(arr, query) {
            return arr.filter(function (obj) {
                if (obj.name)
                    return obj.name.toLowerCase().indexOf(query.toLowerCase()) != -1;
            });
        }
        function setIcon(id, layout) {
            objectManager.objects.setObjectOptions(id, {
                iconLayout: layout,
            });
        }
        function closeInfoPanelAnimation() {
            $mapInfoPanel.classList.remove(INFO_INFOPANEL_ACTIVE_CLASS);
        }
        function openInfoPanelAnimation() {
            setTimeout(() => {
                $mapInfoPanel.classList.add(INFO_INFOPANEL_ACTIVE_CLASS);
            }, 0);
        }
    });
}
